import {ErrorAction} from '@/services/ErrorsService/ErrorsService.constants';

import {ErrorCode, HttpStatus} from '@specials/project-user';

import config from './config';
import content from './content';
import {errors} from './errors';

export const resources = {config, content, errors};

export type ResourcesAll = typeof resources;

export interface ErrorResourcesContent {
  title: string;
  buttonText?: string;
  action?: ErrorAction;
  text?: string;
}

export interface ErrorResourcesBase {
  mb: ErrorResourcesContent;
  web: ErrorResourcesContent;
}

interface ErrorResourcesErrorCodes extends ErrorResourcesBase {
  errorCodes: ErrorCode[];
}

interface ErrorResourcesHttpCodes extends ErrorResourcesBase {
  httpCodes: HttpStatus[];
}

export interface ResourcesErrors {
  errorCodes: ErrorResourcesErrorCodes[];
  httpCodes: ErrorResourcesHttpCodes[];
  fallback: ErrorResourcesBase;
}
